import { useQuery } from "@tanstack/react-query"

import { getMedico } from "../services/medicoview.service";

export const useMedico = (id) => {

    const medicoQuery = useQuery({
        queryKey: ['medico', id],
        queryFn: () => getMedico(id),
        staleTime: 1000 * 60 * 5, // 5 min
    });

    return {
        medicoQuery
    }
}